<template>
  <div class="customer-manage special-member conmon-top special-customer table-first-style">
        <div class="base-input ovf-hd" style="margin-bottom: 10px">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
              <el-button class="fold-button" type="text" @click="hide=!hide" v-show="!hide">简单查询</el-button>
              <el-button class="fold-button" type="text" @click="hide=!hide" v-show="hide">高级查询</el-button>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i"></i>
              <el-button class="search-btn-new" type="primary" v-show="hide" size="small" @click="searchLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide">
            <el-col :span="24" class="text-align-left">
              <span class="filter-record">输入搜索:</span>
              <el-input placeholder="会员名/手机号搜索" v-model="searchTmp.keywords" clearable></el-input>
            </el-col>
          </el-row>
          <!--高级查询-->
          <el-row class="search-content" style="min-height: 210px;height: auto" v-show="!hide">
            <div style="text-align: left;">
              <el-button type="primary" class="save-btn" @click="reset">重置</el-button>
              <el-button type="primary" class="save-btn" @click="startSearchQuery">开始查询</el-button>
            </div>
            <div style="text-align: left;padding-bottom: 10px">
              <span style="margin-left: 20px">查询条件:</span>
            </div>
            <higher-search class="common-search-formtype customer-manage-higher-search" :forSonTerms="forSonTerms" v-bind:allRelationshipSearch="allRelationshipSearch" @change="getAllTerms" style="margin-top: 10px"></higher-search>
          </el-row>
        </div>
        <el-row class="search-title common-table-top">
          <el-col :span="4" class="table-title">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span class="list-title">会员列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right">
            <el-button type="primary" class="search-btn-new" @click="downloadCustomer" style="margin-right:13px!important">导出</el-button>
          </el-col>
        </el-row>
        <el-table ref="multipleTable" :data="tableData" class="table" v-loading="loading">
          <!-- <el-table-column label="头像" width="80">
            <template slot-scope="scope">
            </template>
          </el-table-column> -->
          <el-table-column
            prop="realname"
            min-width="130"
            label="会员">
            <template slot-scope="scope">
              <img :src="scope.row.avatar | showImgUrl" alt="" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%;float:left;margin-right:10px;">
              <div v-if="scope.row.realname !== ''" style="line-height: 32px;">{{ scope.row.realname }}</div>
              <div v-if="scope.row.realname === ''" style="line-height: 32px;">{{ scope.row.nickname }}</div>
              <div v-if="scope.row.realname === '' && scope.row.nickname === ''" style="line-height: 32px;">未知</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="stage_name"
            label="当前等级"
            width="110">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            width="110">
          </el-table-column>
          <el-table-column
            prop="sex"
            width="70"
            label="性别">
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.sex === 0">保密</div> -->
              <div v-if="scope.row.sex === 1">男</div>
              <div v-if="scope.row.sex === 2">女</div>
            </template>
          </el-table-column>
          <el-table-column
            label="等级" width="110">
            <template slot-scope="scope">
              <div>{{ memberLevelList[scope.row.grade] }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="integral"
            width="100"
            label="可用积分">
          </el-table-column>
          <el-table-column
            width="135"
            label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.create_time | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            label="地区">
            <template slot-scope="scope">
              <div v-if="scope.row.city_name !== ''">{{ scope.row.province_name }}{{ scope.row.city_name }}{{ scope.row.district_name }}
              </div>
              <div v-if="scope.row.city_name == ''">
                未知
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" style="display: flex;justify-content: center">
            <template slot-scope="scope">
              <router-link :to="{ name: 'memberDetails', query: { id: scope.row.id }}" class="op-link" style="margin-left: 0;color:#4882ff;text-decoration: none">
                查看
              </router-link>
            </template>
          </el-table-column>
        </el-table>

    <div class="table-foot" style="text-align: right">
      <span style="font-weight: 400;color: #606266;font-size: 13px;line-height: 40px;">共 {{ totalCount }} 条</span>
      <el-pagination
        class="table-foot-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="limit"
        layout="prev, pager, next"
        :total="len">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { exportCustomer, getMemberList, addCustomer, deleteCustomer, addGroup, getCustomerListHigher, saveQuerycondition, getQueryCondition, getMemberLevelList } from '@/api/customer.js'
import HigherSearch from './../common/higher-search.vue'
import { mapMutations, mapGetters } from 'vuex'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'customerManage',
  data () {
    return {
      loading: true,
      searchValue: '',
      tableData: [],
      limit: 10,
      totalCount: 0,
      addGroup: false,
      saveSearch: false,
      addForm: {
        name: '',
        phone: '',
        sex: 1,
        mobile_verified: 1
      },
      addGroupForm: {
        name: ''
      },
      saveSearchForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchTmp: {
        keywords: ''
      },
      search: {
        keywords: ''
      },
      isDisabled: false,
      isDisabledQuery: false,
      isDisabledSearch: false,
      allTerms: {},
      lastId: 0,
      searchType: 0,
      allRelationshipSearch: '',
      forSonTerms: [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ],
      result: [],
      len: 0,
      changeSearchValue: '',
      // 会员等级
      memberLevelList: {},
      isShowSearchRes: false,
      butsObj: { // button按钮列表
        status_change: false,
        add: false,
        edit: false,
        del: false
      }
    }
  },
  components: {
    'higher-search': HigherSearch
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ])
  },
  methods: {
    ...mapMutations([
      'setQuery'
    ]),
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    searchLoad() {
      this.search = JSON.parse(JSON.stringify(this.searchTmp))
      this.page = 1
      this.lastId = 0
      this.load()
    },
    // 筛选条件select查询
    searchOptionsChange(value) {
      if (value === '') {
        this.page = 1
        this.searchType = 0
        this.lastId = ''
        this.load()
      } else {
        this.page = 1
        let termsArr = {}
        this.changeSearchValue = value
        for (let item of this.searchOptions) {
          if (item.id == value) {
            termsArr = item.query
          }
        }
        getMemberList(this.page, this.lastId, termsArr).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data.list
            this.result = []
            for (let i = 0; i < data.length; i += 10) {
              this.result.push(data.slice(i, i + 10))
            }
            // 计算总体请求数据的长度
            this.len = 0
            for (let item of this.result) {
              this.len = this.len + item.length
            }
            this.tableData = this.result[0]
            this.totalCount = res.data.data.count
          }
        })
        this.searchType = 2
      }
    },
    downloadCustomer() {
      if (this.customerCount === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let search = {}
      if (!this.hide) {
        for (let item of this.allTerms.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            one.option = null
            one.relationOptions = null
            one.optionOther = null
            one.qrcodeOptions = null
            one.templateOption = null
          }
        }
        search = this.allTerms
      } else {
        search = this.search
      }
      console.log('101', search)
      let gold = {
        realname: '真实姓名',
        stage_id: '当前等级',
        mobile: '手机号',
        sex: '性别',
        grade: '等级',
        integral: '可用积分',
        create_time: '创建时间',
        province: '省',
        city: '市',
        district: '区'
      }
      exportCustomer(search, gold, 1).then(response => {
        console.log('responseresponseresponse', response)
        _g.toastMsg('href', '')
        // this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    // 改变查询类型
    changeSearchType() {
      this.hide = !this.hide
      if (this.hide === false) {
        this.search.keywords = ''
        this.page = 1
        this.lastId = 0
        this.searchType = 0
        this.load()
      } else {
        this.page = 1
        this.lastId = 0
        this.load()
      }
    },
    // 重置
    reset() {
      this.forSonTerms = [
        {
          inOperator: 'and',
          terms: [
            {
              attr: 'attr',
              relationship: '',
              relationOptions: [
                {
                  value: '=',
                  label: '等于'
                }, {
                  value: '!=',
                  label: '不等于'
                }, {
                  value: 'contain',
                  label: '包含'
                }, {
                  value: 'empty',
                  label: '为空'
                },
                {
                  value: 'not empty',
                  label: '不为空'
                }
              ],
              value: null,
              original_id: null,
              eventAttributeList: [],
              activitiesTwo: [],
              templatesTwo: [],
              wepageTwo: [],
              eventAttrOptions: [
                {
                  attributeContent: '',
                  relationOptions: [],
                  sources: [],
                  eventAttrValueOptions: [],
                  attributeRelation: '',
                  attr_type: '',
                  attrValTimeStart: '',
                  attrValTimeEnd: '',
                  attributeValueStart: '',
                  attributeValueEnd: '',
                  attributeValue: ''
                }
              ],
              optionOther: null,
              qrcodeOptions: null,
              templateOption: null,
              qrcode: null,
              offline_qrcode: null,
              template_id: null,
              leave_word: null,
              public_reply_type_all: {
                reply_type: '不限',
                reply_content: ''
              },
              eventLimitTime: false,
              eventLimitTimes: false,
              eventLimitAttr: false,
              eventTimeRelation: '',
              eventDateStart: '',
              eventDateEnd: '',
              happenedTimes: '',
              start_time: '',
              end_time: '',
              selectedOptions: ['attr', 'realname@input']
            }
          ]
        }
      ]
      this.page = 1
      this.lastId = ''
      this.allTerms.termsGroup = this.forSonTerms
      this.load()
      this.setQuery({})
    },
    // 导入客户
    uploadCustomer() {
      router.push('/home/import-data')
    },
    // 确认添加为动态群组
    confirmAddGroup() {
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      // 防止重复点击
      this.isDisabledQuery = true
      addGroup(this.addGroupForm.name, 1, this.allTerms).then((res) => {
        if (res.data.code === 0) {
          this.isDisabledQuery = false
          this.addGroup = false
          router.push('/home/group-manage')
          _g.toastMsg('success', '添加群组成功')
        } else {
          this.isDisabledQuery = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 获取子组件的查询条件
    getAllTerms(value) {
      this.allTerms = value
    },
    // 确认保存筛选条件
    confirmSaveSearch() {
      for (let item of this.allTerms.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      saveQuerycondition(this.saveSearchForm.name, this.allTerms).then((res) => {
        this.saveSearch = false
        if (res.data.code === 0) {
          _g.toastMsg('success', '添加成功')
        } else {
          _g.toastMsg('success', '添加失败')
        }
      })
    },
    // 点击开始查询
    startSearchQuery() {
      this.isShowSearchRes = false
      this.searchQuery()
    },
    // 开始高级查询
    searchQuery() {
      // 判断是否为空
      if (this.isShowSearchRes === false) {
        for (let i in this.allTerms.termsGroup) {
          let item = this.allTerms.termsGroup[i]
          for (let j in item.terms) {
            if (item.terms[j].selectedOptions[0] === 'attr') {
              if (item.terms[j].relationship === '') {
                _g.toastMsg('error', '请选择相对关系')
                return
              }
            }
            // 判断客户属性是否为空
            if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
              if (item.terms[j].attr === 'attr') {
                // 判断是否是时间且为区间
                if (item.terms[j].selectedOptions[1].split('@')[1] === 'datePicker' || item.terms[j].selectedOptions[1].split('@')[1] === 'dateTimePicker') {
                  if (item.terms[j].relationship === 'gtele') {
                    if (item.terms[j].start_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      起始时间值不能为空')
                      return
                    }
                    if (item.terms[j].end_time === '') {
                      _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      结束时间值不能为空')
                      return
                    }
                  } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                    _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                } else if (item.terms[j].value === '' || item.terms[j].value === null || item.terms[j].value.length === 0) {
                  _g.toastMsg('error', '客户属性-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
            }
            // 判断群组是否为空
            if (item.terms[j].attr === 'group') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '群组-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断客户事件是否为空
            if (item.terms[j].attr === 'event') {
              // 需要选内容的
              if (
                item.terms[j].selectedOptions[2].split('@')[0] === 'click_menu' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'click_page_link' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'form_data' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_wechat' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'leaving_message' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'send_tpl_message' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'red_packet' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'submit_form' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'subscribe' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'unsubscribe' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'view_page' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'wechat_goods_exchange' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_qrcode' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' ||
                item.terms[j].selectedOptions[2].split('@')[0] === 'forward_to_we_friend'
              ) {
                if (item.terms[j].value === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '      值不能为空')
                  return
                }
              }
              // 如果是微信回复
              if (item.terms[j].selectedOptions[2].split('@')[0] === 'public_to_reply') {
                if (item.terms[j].value === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信公众号不能为空')
                  return
                }
                if (item.terms[j].public_reply_type_all.reply_type === null || item.terms[j].public_reply_type_all.reply_type === '') {
                  _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     微信回复类型不能为空')
                  return
                }
              }
              // 限制属性
              if (item.terms[j].eventLimitAttr === true) {
                console.log('102')
                if (item.terms[j].selectedOptions[1] !== 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                  }
                }
                if (item.terms[j].selectedOptions[1] === 'order') {
                  for (let yi of item.terms[j].eventAttrOptions) {
                    if (yi.attributeContent.length === 0) {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性名称不能为空')
                      return
                    }
                    if (yi.attributeRelation === '') {
                      _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性相对关系不能为空')
                      return
                    }
                    if (yi.attributeRelation !== 'empty' && yi.attributeRelation !== 'not_empty' && yi.attributeRelation !== 'gtele') {
                      if (yi.attributeValue === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性值不能为空')
                        return
                      }
                    }
                    if (yi.attributeRelation === 'gtele') {
                      if (yi.attrValTimeStart === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间起始值不能为空')
                        return
                      }
                      if (yi.attrValTimeEnd === '') {
                        _g.toastMsg('error', '客户事件-' + item.terms[j].attr_label + '     限制属性下单时间结束值不能为空')
                        return
                      }
                    }
                  }
                }
              }
              // 限制起止时间
              if (item.terms[j].eventLimitTime === true) {
                if (item.terms[j].eventDateStart === '' || item.terms[j].eventDateEnd === '') {
                  _g.toastMsg('error', '请选择起止时间')
                  return
                }
              }
              // 限制发生次数
              if (item.terms[j].eventCheckbox2 === true) {
                if (item.terms[j].eventSearchTimesSelect === '') {
                  _g.toastMsg('error', '请选择发生次数相对关系')
                  return
                }
                if (item.terms[j].eventSearchTimesSelect !== 'gtele') {
                  if (item.terms[j].happenedTimes === '') {
                    _g.toastMsg('error', '发生次数不能为空')
                    return
                  }
                }
                if (item.terms[j].eventSearchTimesSelect === 'gtele') {
                  if (item.terms[j].happenedTimes_from === '' || item.terms[j].happenedTimes_to === '') {
                    _g.toastMsg('error', '发生次数区间值不能为空')
                    return
                  }
                }
              }
            }
            // 判断关注公众号是否为空
            if (item.terms[j].attr === 'follow_public') {
              if (item.terms[j].value === '' || item.terms[j].value === null) {
                _g.toastMsg('error', '关注公众号-' + item.terms[j].attr_label + '      值不能为空')
                return
              }
            }
            // 判断关客户关键指标是否为空
            if (item.terms[j].attr === 'customer_kpi') {
              if (item.terms[j].relationship !== 'empty' && item.terms[j].relationship !== 'not empty') {
                if (item.terms[j].relationship !== 'gtele') {
                  if (item.terms[j].value === '' || item.terms[j].value === null || typeof item.terms[j].value === 'undefined') {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      值不能为空')
                    return
                  }
                }
                if (item.terms[j].relationship === 'gtele') {
                  if (typeof item.terms[j].gtele_end === 'undefined' || typeof item.terms[j].gtele_start === 'undefined' || item.terms[j].gtele_start === '' || item.terms[j].gtele_end === null || item.terms[j].gtele_end === '' || item.terms[j].gtele_start === null) {
                    _g.toastMsg('error', '客户关键指标-' + item.terms[j].attr_label + '      区间值不能为空')
                    return
                  }
                }
              }
            }
          }
        }
      }
      this.searchType = 1
      this.page = 1
      this.lastId = ''
      let termsSend = JSON.parse(JSON.stringify(this.allTerms))
      console.log('1021', termsSend)
      for (let item of termsSend.termsGroup) {
        for (let one of item.terms) {
          let str = ''
          if (one.selectedOptions[0] === 'event') {
            str = one.selectedOptions[2].split('@')
          } else {
            str = one.selectedOptions[1].split('@')
          }
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
          one.secAttr = str[0]
          one.option = null
          one.relationOptions = null
          one.optionOther = null
          one.qrcodeOptions = null
          one.templateOption = null
        }
      }
      getMemberList(this.page, this.lastId, termsSend).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data.list
          this.result = []
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.tableData = this.result[0]
          this.totalCount = res.data.data.count
        }
        this.openLoading()
      })
      // 保存筛选条件到本地
      this.setQuery(this.allTerms)
    },
    // 收起筛选和展开筛选
    closeAndOpen() {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.lastId = this.tableData[this.tableData.length - 1].id
    },
    handleCurrentChange(page) {
      this.page = page
      this.tableData = this.result[page - 1]
      this.lastId = this.tableData[this.tableData.length - 1].id
      if (this.lastId === this.result[this.result.length - 1][9].id) {
        if (this.searchType === 1) {
          let termsSend = JSON.parse(JSON.stringify(this.allTerms))
          for (let item of termsSend.termsGroup) {
            for (let one of item.terms) {
              let str = ''
              if (one.selectedOptions[0] === 'event') {
                str = one.selectedOptions[2].split('@')
              } else {
                str = one.selectedOptions[1].split('@')
              }
              let firAttr = one.selectedOptions[0]
              one.attr = firAttr
              one.secAttr = str[0]
              one.option = null
              one.relationOptions = null
              one.optionOther = null
              one.qrcodeOptions = null
              one.templateOption = null
            }
          }
          getMemberList(this.page, this.lastId, termsSend).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
            }
          })
        } else if (this.searchType === 0) {
          getMemberList(this.page, this.lastId, this.search).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
            }
          })
        } else if (this.searchType === 2) {
          let termsArr = {}
          for (let item of this.searchOptions) {
            if (item.id == this.changeSearchValue) {
              termsArr = item.query
            }
          }
          getMemberList(this.page, this.lastId, termsArr).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data.list
              for (let i = 0; i < data.length; i += 10) {
                this.result.push(data.slice(i, i + 10))
              }
              // 计算总体请求数据的长度
              this.len = 0
              for (let item of this.result) {
                this.len = this.len + item.length
              }
              this.tableData = this.result[page - 1]
              this.totalCount = res.data.data.count
            }
          })
        }
      }
    },
    // 加载列表
    load() {
      this.loading = true
      let querys = {}
      if (this.hide === false) {
        console.log('502')
        let termsSend = JSON.parse(JSON.stringify(this.allTerms))
        for (let item of termsSend.termsGroup) {
          for (let one of item.terms) {
            let str = ''
            if (one.selectedOptions[0] === 'event') {
              str = one.selectedOptions[2].split('@')
            } else {
              str = one.selectedOptions[1].split('@')
            }
            let firAttr = one.selectedOptions[0]
            one.attr = firAttr
            one.secAttr = str[0]
            one.option = null
            one.relationOptions = null
            one.optionOther = null
            one.qrcodeOptions = null
            one.templateOption = null
          }
        }
        querys = termsSend
      } else {
        console.log('503')
        querys = this.search
      }
      getMemberList(this.page, this.lastId, querys).then((res) => {
        if (res.data.code === 0) {
          this.result = []
          let data = res.data.data.list
          for (let i = 0; i < data.length; i += 10) {
            this.result.push(data.slice(i, i + 10))
          }
          // 计算总体请求数据的长度
          this.len = 0
          for (let item of this.result) {
            this.len = this.len + item.length
          }
          this.tableData = this.result[0]
          this.totalCount = res.data.data.count
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 删除
    deleteItem(item) {
      this.$confirm('确认删除该客户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomer(item.id).then((res) => {
          setTimeout(() => {
            if (res.data.code === 0) {
              this.load()
            }
          }, 1000)
        })
      })
    },
    // 弹窗确定
    confirmAdd() {
      // 添加弹窗
      this.isDisabled = true
      addCustomer(this.addForm.name, this.addForm.phone, this.addForm.mobile_verified, this.addForm.sex).then((res) => {
        if (res.data.code === 0) {
          this.isDisabled = false
          this.addForm.name = ''
          this.addForm.phone = ''
          setTimeout(() => {
            this.load()
          }, 2000)
          _g.toastMsg('success', '添加成功')
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getMemberLevel() {
      getMemberLevelList(1, {}).then(res => {
        for (let i in res.data.data.list) {
          let item = res.data.data.list[i]
          this.memberLevelList[item.id] = item.level_title
        }
        this.load()
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      let query = JSON.parse(sessionStorage.getItem('memberQuery'))
      vm.isShowSearchRes = true
      if (query) {
        vm.allTerms = query
        vm.hide = false
        vm.forSonTerms = vm.allTerms.termsGroup
        vm.allRelationshipSearch = vm.allTerms.allRelationship
        sessionStorage.removeItem('memberQuery')
      } else {
        vm.allTerms = {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  relationship: '',
                  relationOptions: [
                    {
                      value: '=',
                      label: '等于'
                    }, {
                      value: '!=',
                      label: '不等于'
                    }, {
                      value: 'contain',
                      label: '包含'
                    }, {
                      value: 'empty',
                      label: '为空'
                    },
                    {
                      value: 'not empty',
                      label: '不为空'
                    }
                  ],
                  value: null,
                  original_id: null,
                  eventAttributeList: [],
                  activitiesTwo: [],
                  templatesTwo: [],
                  wepageTwo: [],
                  eventAttrOptions: [
                    {
                      attributeContent: '',
                      relationOptions: [],
                      sources: [],
                      eventAttrValueOptions: [],
                      attributeRelation: '',
                      attr_type: '',
                      attrValTimeStart: '',
                      attrValTimeEnd: '',
                      attributeValueStart: '',
                      attributeValueEnd: '',
                      attributeValue: ''
                    }
                  ],
                  optionOther: null,
                  qrcodeOptions: null,
                  templateOption: null,
                  qrcode: null,
                  offline_qrcode: null,
                  template_id: null,
                  leave_word: null,
                  public_reply_type_all: {
                    reply_type: '不限',
                    reply_content: ''
                  },
                  eventLimitTime: false,
                  eventLimitTimes: false,
                  eventLimitAttr: false,
                  eventTimeRelation: '',
                  eventDateStart: '',
                  eventDateEnd: '',
                  happenedTimes: '',
                  start_time: '',
                  end_time: '',
                  selectedOptions: ['attr', 'realname@input']
                }
              ]
            }
          ]
        }
        vm.forSonTerms = [
          {
            inOperator: 'and',
            terms: [
              {
                attr: 'attr',
                relationship: '',
                relationOptions: [
                  {
                    value: '=',
                    label: '等于'
                  }, {
                    value: '!=',
                    label: '不等于'
                  }, {
                    value: 'contain',
                    label: '包含'
                  }, {
                    value: 'empty',
                    label: '为空'
                  },
                  {
                    value: 'not empty',
                    label: '不为空'
                  }
                ],
                value: null,
                original_id: null,
                eventAttributeList: [],
                activitiesTwo: [],
                templatesTwo: [],
                wepageTwo: [],
                eventAttrOptions: [
                  {
                    attributeContent: '',
                    relationOptions: [],
                    sources: [],
                    eventAttrValueOptions: [],
                    attributeRelation: '',
                    attr_type: '',
                    attrValTimeStart: '',
                    attrValTimeEnd: '',
                    attributeValueStart: '',
                    attributeValueEnd: '',
                    attributeValue: ''
                  }
                ],
                optionOther: null,
                qrcodeOptions: null,
                templateOption: null,
                qrcode: null,
                offline_qrcode: null,
                template_id: null,
                leave_word: null,
                public_reply_type_all: {
                  reply_type: '不限',
                  reply_content: ''
                },
                eventLimitTime: false,
                eventLimitTimes: false,
                eventLimitAttr: false,
                eventTimeRelation: '',
                eventDateStart: '',
                eventDateEnd: '',
                happenedTimes: '',
                start_time: '',
                end_time: '',
                selectedOptions: ['attr', 'realname@input']
              }
            ]
          }
        ]
        vm.hide = true
      }
      vm.searchQuery()
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (to.path === '/home/member-details') {
      sessionStorage.setItem('memberQuery', JSON.stringify(this.allTerms))
    }
    next()
  },
  mounted() {
  },
  created() {
    let query = JSON.parse(sessionStorage.getItem('memberQuery'))
    if (!query) {
      this.getMemberLevel()
    }
    console.log('duanxin页面')
    this.getButtonsList()
  }
}
</script>

<style scoped>
.green{
    color: #05B324;
}
.red{
    color: #FF2B2B;
}
.save-btn{
  border-radius: 16px;
  padding: 9px 17px;
  font-size: 14px;
  height: 30px;
  float: right;
  color: #fff;
  cursor: pointer;
  border: none;
}
.el-radio-group{
  margin-top: -13px;
}
.text-align-left{
  text-align: left;
}
.text-align-right{
  text-align: right;
}
.table-title{
  text-align: left;
}
.add-btn {
  padding: 0 15px;
  height: 30px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #1890FF;
  margin-top: 5px;
  cursor: pointer;
}
</style>
